<template>
  <div class="guide-content">
    <div class="news_title">
      {{
        this.arcitleData && this.arcitleData[0] && this.arcitleData[0]["abstracts"]
          ? this.arcitleData[0]["abstracts"]
          : ""
      }}
    </div>
    <div
      class="content"
      :style="{ paddingLeft: '24px', width: '100%' }"
      v-html="
        this.arcitleData && this.arcitleData[0] && this.arcitleData[0]['html']
          ? this.arcitleData[0]['html']
          : ''
      "
    ></div>
  </div>
</template>

<script>
import { mixinResourceHelp } from "./mixins/resource-help";
// import moment from "moment";
export default {
  mixins: [mixinResourceHelp],
  data() {
    return {
      openKeys: [],
      arcitleData: [],
    };
  },
  mounted() {
    this.getDetail();
  },

  methods: {
    async getDetail() {
      await this.getArcitleTypeData({ id: this.$route.params.did });
      let openKeys =
        this.arcitleData && this.arcitleData[0] && this.arcitleData[0]["titleId"]
          ? this.arcitleData[0]["titleId"]
          : "";

      this.$emit("dealOpenChange", openKeys);
      let title = this.arcitleData && this.arcitleData[0] && this.arcitleData[0]["abstracts"]
        ? this.arcitleData[0]["abstracts"]
        : "";
      document.title = title + '-AB客'
      // console.log(this.arcitleData, this.openKeys, "====this.openKeysthis.openKeys====");
    },
  },
  watch: {
    $route(newRoute) {
      this.getDetail();
    },
  },
};
</script>

<style lang="sass" scoped>
.news_title{
  font-size:40px;
  color:#333;
  text-align: center;
}
.content{
  width: 100%;
  word-break: break-all;
  word-wrap: break-word;
  padding-top:20px;
  font-size: 18px;
  font-family: 'Alibaba-PuHuiTi-R' !important;
  color: #333646;
  line-height: 30px;
  p{
    padding-bottom:10px;
    // font-family: 'Alibaba-PuHuiTi-R' !important;
  }
  img{
    max-width:100%;

  }

  ::v-deep {
    * {
      font-family: 'Alibaba-PuHuiTi-R' !important;
      // font-size: 18px;
    }
  }

}
</style>
